import { Component, input, Input, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AverageMttrResponse, QueryType } from 'src/app/core/services/analytics.service';
import { environment } from 'src//environments/environment';
import { DialogsModule } from '@progress/kendo-angular-dialog';
import { GridModule, ExcelModule, GridDataResult } from '@progress/kendo-angular-grid';
import { Observable } from 'rxjs';
import { MttrDetailsService } from './services/mttrdetails.service';
import { DATE_FILTER_OPERATORS } from 'src/app/core/constants/filter-operators';

@Component({
  selector: 'app-mttr-card',
  standalone: true,
  imports: [CommonModule, DialogsModule, GridModule, ExcelModule],
  templateUrl: './mttr-card.component.html',
  styleUrl: './mttr-card.component.scss',
  providers: [MttrDetailsService],
})
export class MttrCardComponent {
  // New signal input for the API response
  averageMttr = input<AverageMttrResponse>(new AverageMttrResponse());

  // Keep old inputs for backward compatibility
  @Input() meanTimeToResolve: number = 0;
  @Input() previousMeanTimeToResolve: number = 0;

  public readonly gridService = inject(MttrDetailsService);
  public showPopup = false;
  public organizationId = input<number | null>();
  public startDate = input<string | null>();
  public endDate = input<string | null>();
  public dateFilterOperators = DATE_FILTER_OPERATORS;
  queryType = input<QueryType>(QueryType.All);
  selectedOrgIds = input<number[]>([]);

  public Math = Math;

  onContextMenuSelect(event: any) {
    if (event?.text === 'View Data') {
      // Determine query type and org IDs based on filter context
      const queryType = this.queryType().toLowerCase(); // 'all' or 'filtered'
      const orgIds =
        this.queryType() === QueryType.Filtered && this.selectedOrgIds().length > 0
          ? this.selectedOrgIds().join(',')
          : this.organizationId();

      const baseQueryString = `org_ids=${orgIds}&type=${queryType}`;
      const queryString = `${baseQueryString}&current_start=${this.startDate()}&current_end=${this.endDate()}`;

      this.gridService.url = `${environment.apiUrl}/v1/analytics/administrative/mttrmetricsdetails(${this.organizationId()})`;
      this.gridService.appendQueryString = queryString;
      this.gridService.read();
      this.showPopup = true;
    } else {
      console.warn('Invalid event structure:', event);
    }
  }

  public allData = (): Observable<GridDataResult> => {
    return this.gridService.queryAll();
  };

  // Close popup
  close() {
    this.showPopup = false;
  }
}
